import React from "react";
import PageLayout, { SectionReveal } from "../components/PageLayout";
import PageHero from "../components/PageHero";
import PageBanner from "../components/PageBanner";
import { Database, Link, RefreshCw, FileText, Check } from "lucide-react";

const CRMPage = () => {
  const crms = [
    { name: "HubSpot", features: ["Kişi kartı oluşturma", "Görüşme özeti kaydı", "Aksiyon maddesi atama", "Anlaşma güncelleme"] },
    { name: "Microsoft Dynamics 365", features: ["Sales modülü entegrasyonu", "Customer Service vaka oluşturma", "Field Service iş emri", "Gerçek zamanlı fırsat güncelleme"] },
    { name: "Zendesk", features: ["Otomatik ticket oluşturma", "Transkript ve duygu skoru ekleme", "Ticket önceliklendirme", "Müşteri geçmişi görüntüleme"] },
    { name: "Freshdesk", features: ["Ticket açma / güncelleme", "Müşteri bilgisi senkronizasyonu", "SLA takibi", "Raporlama entegrasyonu"] },
  ];

  const features = [
    { icon: Database, title: "Otomatik Veri Girişi", desc: "Her görüşme sonrası transkript, özet, duygu skoru ve aksiyon maddeleri CRM'inize otomatik kaydedilir. Manuel veri girişine son." },
    { icon: RefreshCw, title: "Çift Yönlü Senkronizasyon", desc: "CRM'deki müşteri bilgileri çağrı sırasında AI ajana anlık aktarılır. AI'ın güncellediği veriler CRM'e anında yazılır." },
    { icon: Link, title: "Tek Tıkla Entegrasyon", desc: "OAuth tabanlı güvenli bağlantı. API anahtarlarıyla uğraşmadan dakikalar içinde entegrasyonu tamamlayın." },
  ];

  const hero = (
    <PageHero
      eyebrow="Ürün"
      title="CRM Entegrasyonu"
      subtitle="HubSpot, Microsoft Dynamics 365, Zendesk ve Freshdesk ile çift yönlü, gerçek zamanlı entegrasyon. Her görüşme CRM'inize otomatik işlenir."
    />
  );

  return (
    <PageLayout hero={hero}>
      <PageBanner src="/images/pages/software-dev.jpg" alt="CRM entegrasyonu" height="360px" />
      <SectionReveal>
        <section className="py-16 px-6">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-3 gap-5 mb-16">
              {features.map((f) => (
                <div key={f.title} className="p-6 rounded-2xl transition-colors duration-200" style={{ background: "var(--card-bg)", border: "1px solid var(--border)" }}>
                  <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-4" style={{ background: "rgba(75,111,212,0.12)", color: "var(--brand-cyan)" }}>
                    <f.icon size={22} />
                  </div>
                  <h3 className="text-[16px] font-semibold mb-2" style={{ color: "var(--fg)" }}>{f.title}</h3>
                  <p className="text-[13.5px] leading-relaxed" style={{ color: "var(--fg)", opacity: 0.82 }}>{f.desc}</p>
                </div>
              ))}
            </div>

            <h2 className="text-[28px] font-bold mb-10 text-center" style={{ color: "var(--fg)" }}>Desteklenen CRM'ler</h2>
            <div className="grid md:grid-cols-2 gap-5">
              {crms.map((crm) => (
                <div key={crm.name} className="p-6 rounded-2xl transition-colors duration-200" style={{ background: "var(--card-bg)", border: "1px solid var(--border)" }}>
                  <h3 className="text-[20px] font-bold mb-1" style={{ color: "var(--fg)" }}>{crm.name}</h3>
                  <div className="grid grid-cols-2 gap-2 mt-4">
                    {crm.features.map((feat) => (
                      <div key={feat} className="flex items-center gap-2 text-[13px]" style={{ color: "var(--fg)", opacity: 0.82 }}>
                        <Check size={13} style={{ color: "#10b981", flexShrink: 0 }} />{feat}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </SectionReveal>

      <SectionReveal>
        <section className="py-16 px-6" style={{ background: "var(--section-surface-1)" }}>
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-[24px] font-bold mb-4" style={{ color: "var(--fg)" }}>Kullandığınız CRM listede yok mu?</h2>
            <p className="text-[15px] mb-8" style={{ color: "var(--fg)", opacity: 0.82 }}>
              Webhook, REST API ve özel entegrasyon katmanımız sayesinde hemen her CRM ile entegre olabiliyoruz. İhtiyacınızı bize iletin, çözüm üretelim.
            </p>
            <a href="mailto:satis@verasist.ai" className="inline-flex items-center gap-2 px-10 py-4 rounded-full font-bold text-[15px] transition-all duration-200" style={{ background: "var(--brand-navy)", color: "#fff" }}>
              <FileText size={18} />Entegrasyon Talebi
            </a>
          </div>
        </section>
      </SectionReveal>
    </PageLayout>
  );
};

export default CRMPage;
